import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Collapse, UncontrolledCollapse } from "reactstrap";
import { useHistory } from "react-router-dom";
import { FaSitemap, FaPlusCircle } from "react-icons/fa";

import WebAddSubDomain from "./WebAddSubDomain";
import WebListArrowButton from "../etc/button/WebListArrowButton";
import WebCreateSubDomainList from "./list/WebCreateSubDomainList";

const WebMyCreateSubDomainList = ({ userSeq, userKind, isStandardType, list_subDomainInfo, isCheckSubDomainOK, isAddSubDomainOK, alertMessage, alertKind, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [isOpened, setIsOpened] = useState(false);
    const [isAddSubDomainOpen, setIsAddSubDomainOpen] = useState(false);
    const [addSubDomainResetEventId, setAddSubDomainResetEventId] = useState(0);

    useEffect(() => {
        if (list_subDomainInfo.length > 0) {
            setIsOpened(true);
        }
    }, [list_subDomainInfo]);

    // 20260813 추가 패널을 닫으면 미저장 입력값과 중복확인 상태를 초기화한다.
    const toggleAddSubDomain = () => setIsAddSubDomainOpen(!isAddSubDomainOpen);
    const resetAddSubDomain = () => {
        handleSelectedFunc({ selectedFunc: "CHANGE_ALERT_MESSAGE", kind: "subDomain-check", message: "" });
        handleSelectedFunc({ selectedFunc: "CHANGE_ALERT_MESSAGE", kind: "subDomain-add", message: "" });
        setAddSubDomainResetEventId(prev => prev + 1);
    }

    const goToPassListPage = ({ subDomainSeq }) => {
        if (subDomainSeq === 1) {
            handleSelectedFunc({ selectedFunc: "GET_PCHS_LIST", kind: "USER", subDomainSeq, selectedUserSeq: userSeq });
        } else {
            handleSelectedFunc({ selectedFunc: "GET_PCHS_LIST", kind: "SUB_DOMAIN", subDomainSeq });
        }
    }

    return (
        // teacher/class 탭과 동일한 app-container / main-title-bar / btn-top-register 스타일 적용
        // (기존 로직·핸들러·props는 그대로 유지, 마크업/className만 교체)
        <div className="web-main admin list-area">
            <div className="app-container">
                <div className="main-title-bar">
                    <div className="title-left">
                        <FaSitemap className="icon-teacher" aria-hidden="true" />
                        <span className="title-text">{t("내가_생성한_서브_도메인", { ns: "admin" })}</span>
                        {
                            (userKind === "hiclasstv" || userKind === "easy") &&
                            <button type="button" className="btn-top-register" onClick={toggleAddSubDomain}>
                                <FaPlusCircle aria-hidden="true" />{t("서브_도메인_추가", { ns: "admin" })}
                            </button>
                        }
                    </div>
                    <WebListArrowButton toggle_id={"myCreateSubDomainList"} list_array={list_subDomainInfo} isOpened={isOpened} />
                </div>
                {
                    (userKind === "hiclasstv" || userKind === "easy") &&
                    <Collapse isOpen={isAddSubDomainOpen} onExited={resetAddSubDomain}>
                        <WebAddSubDomain
                            key={addSubDomainResetEventId}
                            isCheckSubDomainOK={isCheckSubDomainOK}
                            isAddSubDomainOK={isAddSubDomainOK}
                            alertKind={alertKind}
                            alertMessage={alertMessage}
                            handleSelectedFunc={handleSelectedFunc}
                        />
                    </Collapse>
                }
                <UncontrolledCollapse toggler="#myCreateSubDomainList" defaultOpen={true} onEntering={() => setIsOpened(true)} onExiting={() => setIsOpened(false)}>
                    <WebCreateSubDomainList
                        isStandardType={isStandardType}
                        list_subDomain={list_subDomainInfo}
                        goToPassListPage={goToPassListPage}
                    />
                </UncontrolledCollapse>
            </div>
        </div>
    );
}

export default WebMyCreateSubDomainList;